import React, { useState, useEffect } from "react";

function CloudbedsBookingWidget() {
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  // Get minimum check-out date (one day after check-in)
  const getMinCheckOutDate = (checkInDate) => {
    if (!checkInDate) return today;
    const date = new Date(checkInDate);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  // Get maximum date (1 year from today)
  const getMaxDate = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    return date.toISOString().split("T")[0];
  };

  // Handle check-in date change
  const handleCheckInChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate && selectedDate >= today) {
      setCheckInDate(selectedDate);
      // If check-out date exists but is now invalid, reset it
      const minCheckOut = getMinCheckOutDate(selectedDate);
      if (checkOutDate && checkOutDate < minCheckOut) {
        setCheckOutDate("");
      }
    }
  };

  // Handle check-out date change
  const handleCheckOutChange = (e) => {
    const selectedDate = e.target.value;
    const minCheckOut = getMinCheckOutDate(checkInDate);
    
    if (selectedDate && selectedDate >= minCheckOut) {
      setCheckOutDate(selectedDate);
    }
  };

  const containerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? '15px' : '20px',
    padding: isMobile ? '15px' : '20px',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto'
  };

  const itemStyles = {
    width: isMobile ? '100%' : '340px',
    margin: 0,
    maxWidth: isMobile ? '100%' : '340px',
  };

  const inputStyles = {
    width: '100%',
    padding: isMobile ? '12px' : '15px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    fontSize: isMobile ? '14px' : '16px',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    backgroundColor: '#fff'
  };

  const buttonStyles = {
    width: isMobile ? '100%' : '230px',
    margin: 0,
    marginTop: isMobile ? '10px' : '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  return (
    <div>
      <div id="booking" className="booking-area p-relative">
        <div className="container">
          <form action="#" className="contact-form">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <ul style={containerStyles}>
                  <li style={itemStyles}>
                    <div className="contact-field p-relative c-name">
                      <label style={{ marginBottom: '10px', display: 'block' }}>
                        <i className="fal fa-badge-check"></i> Check In
                      </label>
                      <input
                        type="date"
                        id="chackin"
                        name="date"
                        min={today}
                        max={getMaxDate()}
                        value={checkInDate}
                        onChange={handleCheckInChange}
                        style={inputStyles}
                      />
                    </div>
                  </li>
                  <li style={itemStyles}>
                    <div className="contact-field p-relative c-name">
                      <label style={{ marginBottom: '10px', display: 'block' }}>
                        <i className="fal fa-times-octagon"></i> Check Out
                      </label>
                      <input
                        type="date"
                        id="chackout"
                        name="date"
                        min={getMinCheckOutDate(checkInDate)}
                        max={getMaxDate()}
                        value={checkOutDate}
                        onChange={handleCheckOutChange}
                        disabled={!checkInDate}
                        style={inputStyles}
                      />
                    </div>
                  </li>
                  <li style={buttonStyles}>
                    <div className="slider-btn" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <label style={{ marginBottom: isMobile ? '12px' : '10px' }}>
                        <i className="fal fa-calendar-alt" style={{ fontSize: isMobile ? '24px' : '26px', color: '#bf8c4c' }}></i>
                      </label>
                      <a
                        className="btn ss-btn"
                        data-animation="fadeInRight"
                        data-delay=".8s"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          width: isMobile ? '80%' : '100%',
                          textAlign: 'center',
                          padding: isMobile ? '12px' : '15px',
                          fontSize: isMobile ? '16px' : '14px',
                          opacity: (!checkInDate || !checkOutDate) ? 0.6 : 1,
                          pointerEvents: (!checkInDate || !checkOutDate) ? 'none' : 'auto',
                          display: 'block'
                        }}
                        href={`https://us2.cloudbeds.com/en/reservation/2C4nnm#checkin=${checkInDate}&checkout=${checkOutDate}`}
                      >
                        Disponibilidad
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CloudbedsBookingWidget;
